// extracted by mini-css-extract-plugin
export var explanationTitle = "explanation-module--explanation-title--83079";
export var explanationWrapper = "explanation-module--explanation-wrapper--845e5";